import BaseApiRequest from "./BaseApiRequest";
import { APPLICANT_CREATE_SELF_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class ApplicantCreateSelf extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = APPLICANT_CREATE_SELF_URL;

  constructor(reqData) {
    super();
    this.body = reqData;
    console.log(reqData);
    console.log(this.body);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
